<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    appointment_channel () {
      return this.$store.getters.appointment_channel
    }
  },
  methods: {
    getAppointment_channel (id) {
      this.$store.dispatch('getAppointment_channel', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAppointment_channel(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>



// WEBPACK FOOTER //
// Appointment_channel.vue?3bde4f28